module.exports = __webpack_public_path__ + "media/student_v2/assets/images/student-alert-checkbox-undeterminate-741d72ab9e3ab60ce1a8ca2a6fa867bd.svg";